import { Admin, CustomRoutes } from "react-admin";
import { Route } from "react-router-dom";
import { authProvider } from "./api/authProvider";
import { dataProvider } from "./api/dataProvider";
import { AdminResources } from "./AdminResources";
import { ADMIN_BASE } from "./constants/paths";
import { i18nProvider } from "./i18n";
import { AdminLayout } from "./layout/AdminLayout";
import { AdminLogin } from "./pages/AdminLogin";
import { Dashboard } from "./pages/Dashboard";
import { PhHelperDigarList, PhHelperMoreList } from "./resources/phHelper";
import { adminStore } from "./store/adminStore";
import { darkTheme, lightTheme } from "./theme";
import type { SelfClaims } from "./api/authProvider";

export const AdminApp = () => (
  <Admin
    basename={ADMIN_BASE}
    title="UQX Admin"
    dataProvider={dataProvider}
    authProvider={authProvider}
    i18nProvider={i18nProvider}
    store={adminStore}
    layout={AdminLayout}
    loginPage={AdminLogin}
    dashboard={Dashboard}
    theme={lightTheme}
    darkTheme={darkTheme}
    requireAuth
  >
    {(permissions: SelfClaims | undefined) => (
      <>
        {AdminResources(permissions)}
        <CustomRoutes>
          <Route path="/helpers/digar" element={<PhHelperDigarList />} />
          <Route path="/helpers/more" element={<PhHelperMoreList />} />
        </CustomRoutes>
      </>
    )}
  </Admin>
);
